export default __webpack_public_path__ + "static/media/copy.65472339.svg";